<main class="main c11 caja-chica">
    <loader-bloqueante bajada="mensaje personalizado" [bloquear]="loaderIssys">
    <article class="card" >
            <box-loader *ngIf="loader"></box-loader>
            <div class="box"> 
                <h2>Ejemplo de loader simple</h2>
                <spinner-simple></spinner-simple>
                <p>Para utilizar cuando se espera la carga de un componente, como un selector o un dato</p>
                <spinner-simple [mensaje]="'Con un mensaje personalizado'"></spinner-simple>
                <spinner-simple [className]="'rojo'"  [mensaje]="'Con una clase personalizada'"></spinner-simple>
            </div>
        </article>
    </loader-bloqueante>
   
    <article class="card box">
        <h2>Ejemplo de loader bloqueante</h2>
        <p>Para esperar el procesamiento de un formulario/acción que impide la realización de otra operación antes de obtener la respuesta</p>
        <button class="btn btn-primary" (click)="load()">{{loader?'Desactivar':'Activar'}} loader</button>
        <button class="btn btn-primary" (click)="load(true)">{{loader?'Desactivar':'Activar'}} loader ISSyS</button>
    </article>
</main>